import { Star, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const AccountCard = ({ account }) => {
  return (
    <Link
      to={`/market/free-fire/accounts/p/${account.slug}`}
      className="card-hover group flex bg-[#111b38]/80 border border-white/5 rounded-xl overflow-hidden"
    >
      {/* Image */}
      <div className="relative w-[42%] shrink-0 bg-[#0b1530]">
        <img
          src={account.image}
          alt={account.title}
          loading="lazy"
          className="w-full h-full object-cover aspect-[4/5]"
        />
        <div className="absolute bottom-2 left-2 flex items-center gap-1.5 px-2 py-1 rounded-md bg-black/60 backdrop-blur-sm">
          <img src={account.seller.avatar} alt={account.seller.name} className="h-5 w-5 rounded-full object-cover" />
          <span className="text-[11px] font-medium text-white truncate max-w-[80px]">{account.seller.name}</span>
          <span className="flex items-center gap-0.5 text-[11px] text-amber-300">
            <Star className="h-3 w-3 fill-amber-300" /> {account.seller.rating}
          </span>
        </div>
        {account.seller.online && (
          <span className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/20 border border-emerald-400/40 text-[10px] text-emerald-300">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> Online
          </span>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 p-3 lg:p-4 flex flex-col">
        <h3 className="text-[13px] lg:text-sm font-semibold text-white leading-snug line-clamp-3 group-hover:text-amber-200">
          {account.title}
        </h3>
        <button className="mt-1 text-[11px] text-sky-400 hover:text-sky-300 w-fit">Show description</button>

        <div className="mt-3 grid grid-cols-2 gap-2 text-[11px]">
          <div>
            <div className="text-slate-400">Type</div>
            <div className="text-white font-medium">{account.type}</div>
          </div>
          <div>
            <div className="text-slate-400">Server</div>
            <div className="text-white font-medium">{account.server}</div>
          </div>
        </div>

        <div className="mt-auto pt-3 flex items-center justify-between">
          <div className="flex items-center gap-1 text-[10px] text-emerald-300">
            <ShieldCheck className="h-3.5 w-3.5" /> Verified
          </div>
          <div className="price-glow text-lg lg:text-xl font-extrabold">
            ${account.price.toFixed(2)}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default AccountCard;
